import { render, staticRenderFns } from "./UnassignEditorsForm.vue?vue&type=template&id=0e979963"
import script from "./UnassignEditorsForm.vue?vue&type=script&lang=ts"
export * from "./UnassignEditorsForm.vue?vue&type=script&lang=ts"
import style0 from "./UnassignEditorsForm.vue?vue&type=style&index=0&id=0e979963&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports